import { currentLocale } from "../../locales";

// Cosmetic only, keyed by process_definitions.slug — an unknown future slug
// falls back to FALLBACK_BADGE_CLASS rather than needing a code change.
export const TYPE_BADGE_CLASS: Record<string, string> = {
  casting: "bg-sky-50 text-sky-700 border-sky-200",
  cutting: "bg-emerald-50 text-emerald-700 border-emerald-200",
  turning: "bg-indigo-50 text-indigo-700 border-indigo-200",
  vmc: "bg-cyan-50 text-cyan-700 border-cyan-200",
  buffing: "bg-amber-50 text-amber-800 border-amber-200",
  platting: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
};

const FALLBACK_BADGE_CLASS = "bg-gray-100 text-gray-700 border-gray-200";

export type TypeChip = { value: string; label: string; className: string };

// Derives badges from the party's actual process_definitions assignments
// (the source of truth) rather than the retired `parties.type` CSV column.
export const getTypeChips = (
  processDefinitions: { id: number; slug: string; name: string; name_gu: string | null }[] | null | undefined
): TypeChip[] => {
  if (!processDefinitions || processDefinitions.length === 0) return [];
  return processDefinitions.map((d) => ({
    value: d.slug,
    label: currentLocale === "gu" && d.name_gu ? d.name_gu : d.name,
    className: TYPE_BADGE_CLASS[d.slug] || FALLBACK_BADGE_CLASS,
  }));
};
